import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Popover, Spin, Typography } from 'antd';

import { useAuthContext } from 'contexts/AuthContext';

export const ContactPopover: React.FC = () => {
  const { t } = useTranslation('contact');
  const [open, setOpen] = useState(false);
  const { owner: data, ownerIsLoading: isLoading } = useAuthContext();

  return (
    <Popover
      trigger="click"
      onOpenChange={setOpen}
      open={open}
      rootClassName="white-popover"
      color="#FFF"
      content={
        <div className="min-w-[200px]">
          <Typography.Paragraph className="!mb-2 font-bold">
            {t('title')}
          </Typography.Paragraph>
          {isLoading && <Spin className="mx-auto" />}
          {!isLoading && !data && (
            <Typography.Paragraph className="!mb-0">
              {t('no_contact')}
            </Typography.Paragraph>
          )}
          {!isLoading && data && (
            <ul className="!mb-0 leading-7">
              <li className="block !m-0" key="owner-name">
                {data.Owner?.Name}
              </li>
              {data.Owner?.Email && (
                <li key="owner-email" className="block !m-0">
                  <a href={`mailto:${data.Owner.Email}`}>{data.Owner.Email}</a>
                </li>
              )}
              {data.Owner?.MobilePhone && (
                <li key="owner-phone" className="block !m-0">
                  <a href={`tel:${data.Owner.MobilePhone}`}>
                    {data.Owner.MobilePhone}
                  </a>
                </li>
              )}
            </ul>
          )}
        </div>
      }
      placement="bottom"
    >
      <Button
        type="text"
        aria-haspopup="dialog"
        aria-expanded={open}
        className="flex items-center gap-2 !h-[34px] !rounded-full !bg-success-bg !px-1 !pr-3"
      >
        <span className="flex h-[26px] w-[26px] items-center justify-center rounded-full bg-agriculture">
          <UserOutlined className="text-sm text-white" />
        </span>
        <span className="text-gris-hellio">{t('title')}</span>
        <DownOutlined className="text-xs text-gris-hellio" />
      </Button>
    </Popover>
  );
};
